import type { AdCopyConceptKey } from "../../../../../../../server/models/ad-copy/concept";

export const orderedConceptTypes = [
	"test1",
	"test2",
	"test3",
	"currentProduct",
	"benchmark",
] as const satisfies ReadonlyArray<AdCopyConceptKey>;
